import React from 'react';
import { Flex } from 'antd';
import { Moment } from 'moment';
import { DATE_AND_TIME, TimeZoneFormat } from '@shared/utils/constants';
import { formatDate } from '@shared/utils/date';
import styles from './RequiredArrivalPopover.module.css';

type ArrivalInfoRowProps = {
	label: string;
	value?: Moment | null;
	timeZoneFormat: TimeZoneFormat;
	fallback?: string;
	className?: string;
};

const ArrivalInfoRow = ({
	label,
	value,
	timeZoneFormat,
	fallback = 'N/A',
	className,
}: ArrivalInfoRowProps) => {
	const timezoneLabel = timeZoneFormat === TimeZoneFormat.LocalTime ? 'LT' : 'UTC';

	return (
		<Flex gap={4} className={className}>
			<strong>{label}</strong>
			<span>
				{value ?
					<>
						{formatDate(value, DATE_AND_TIME, false, timeZoneFormat)}{' '}
						<span className={styles.timezoneInline}>{timezoneLabel}</span>
					</> :
					fallback
				}
			</span>
		</Flex>
	);
};

export default ArrivalInfoRow;